import { graphql, useMutation } from "react-relay"
import {
  CallPatientInput,
  useCallPatientMutation as useCallPatientMutationType,
} from "@/modules/telephony/services/__generated__/useCallPatientMutation.graphql"
import { useGenesysMutationErrorHandling } from "@/modules/telephony/services/useGenesysMutationErrorHandling"

const callPatientMutation = graphql`
  mutation useCallPatientMutation($input: CallPatientInput!) {
    callPatient(input: $input) {
      callPatientOutput {
        conversationId
      }
      errors {
        ... on AgentNotAuthenticated {
          __typename
        }
        ... on InvalidPatientPhoneNumber {
          __typename
        }
        ... on CallAlreadyInProgress {
          __typename
        }
      }
    }
  }
`

const callPatientErrorMessageKeyByTypename = {
  InvalidPatientPhoneNumber: "episodeOfCare.outBoundCallButton.invalidPhoneNumber",
  CallAlreadyInProgress: "episodeOfCare.outBoundCallButton.callAlreadyInProgress",
}

const useCallPatientMutation = () => {
  const [commit, isInFlight] = useMutation<useCallPatientMutationType>(callPatientMutation)
  const commitWithGenesysErrorHandling = useGenesysMutationErrorHandling(
    commit,
    (response) => response.callPatient.errors,
    callPatientErrorMessageKeyByTypename,
  )

  const callPatient = (
    callPatientInput: CallPatientInput,
    onCallPlaced: VoidFunction,
    onAgentNotAuthenticated: VoidFunction,
  ) => {
    commitWithGenesysErrorHandling({
      variables: { input: callPatientInput },
      onCompleted: onCallPlaced,
      onAgentNotAuthenticated,
    })
  }

  return [callPatient, isInFlight] as const
}

export { useCallPatientMutation }
